import { hostHas } from './host-capabilities';

/**
 * The modifier that steps to the next or previous document with Page Down / Page Up.
 *
 * The desktop's is Ctrl. A browser keeps Ctrl+Page Down and Ctrl+Page Up for switching its own tabs
 * and never hands them to the page, so in a host without `ctrl-page-keys` the same step is Alt
 * (Alt+Page Down / Alt+Page Up reach the page in every browser). The review screen answers both
 * everywhere; this names the one the host's people are told about, in tooltips and the F1 sheet.
 */
export const documentStepModifier = (): 'Ctrl' | 'Alt' =>
  hostHas('ctrl-page-keys') ? 'Ctrl' : 'Alt';

/** Whether a Page Up / Page Down key event asks for the next or previous document rather than page. */
export const stepsDocument = (event: Pick<KeyboardEvent, 'ctrlKey' | 'altKey'>): boolean =>
  event.ctrlKey || event.altKey;
